var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2215 22.5H7.77852C5.49304 22.5 4.18845 20.2011 5.55973 18.5901C6.1668 17.877 6.54092 17.0311 6.6416 16.1441L7.20058 11.219C7.50199 8.56329 9.48457 6.38399 12.1626 5.46708V5.33743C12.1626 3.77036 13.4329 2.5 15 2.5C16.5671 2.5 17.8374 3.77036 17.8374 5.33743V5.46708C20.5154 6.38399 22.498 8.56329 22.7994 11.219L23.3584 16.1441C23.4591 17.0311 23.8332 17.877 24.4403 18.5901C25.8116 20.2011 24.507 22.5 22.2215 22.5ZM18.7151 25.0894C18.1434 26.499 16.6957 27.5 15 27.5C13.3043 27.5 11.8566 26.499 11.2849 25.0894C11.261 25.0306 11.25 24.9675 11.25 24.9041C11.25 24.6119 11.4869 24.375 11.7791 24.375H18.2209C18.5131 24.375 18.75 24.6119 18.75 24.9041C18.75 24.9675 18.739 25.0306 18.7151 25.0894Z",
    fill: "#EB7EA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification2);
export default __webpack_public_path__ + "static/media/notification2.9baef301643469e0554a163324708834.svg";
export { ForwardRef as ReactComponent };